<script setup>
import { ref } from 'vue';
import BtnPill from '@/components/btn/BtnPill.vue';
import { GA } from '@/mixins/Ga';

defineProps({
    color: {
        type: String,
        default: 'blue',
    },
    mainColor: {
        type: String,
        default: 'blue',
    },
    cta: {
        type: [String, Boolean],
        default: '',
    },
    image: {
        type: Array,
        default: () => [],
    },
    ctaLink: {
        type: String,
        default: '',
    },
    ctaMain: {
        type: String,
        default: 'En savoir plus',
    },
    ctaSmall: {
        type: [String, Boolean],
        default: '',
    },
    ctaMainSub: {
        type: String,
        default: '',
    },
    title: {
        type: String,
        default: '',
    },
    btnIcon: {
        type: [String, Boolean],
        default: '',
    },
    ctaMainLink: {
        type: [String, Object],
        default: '',
    },
    ctaMainLinkNewTab: {
        type: Boolean,
        default: false,
    },
    ctaLinkNewTab: {
        type: Boolean,
        default: false,
    },
});

const rootEl = ref(null);
const ga = new GA({ category: 'endBody', action: 'clicInterne' });
</script>

<template>
    <div
        ref="rootEl"
        class="RecipeProductCta mb-16 flex flex-col shadow-xl md:my-24 md:flex-row"
        :class="[
            'text-dark-' + mainColor,
            'bg-light-' + mainColor,
            {
                '!text-white': mainColor == 'indigo',
            },
        ]"
    >
        <div
            class="RecipeProductCta__card RecipeProductCta__parallax group relative order-2 mx-6 -mb-12 flex text-white md:order-none md:-ml-48 md:-mt-12 md:mr-0 xl:-ml-4"
        >
            <component
                :is="ctaLink ? (typeof ctaLink == 'string' && ctaLink.startsWith('http') ? 'a' : 'router-link') : 'div'"
                class="RecipeProductCta__parallax-inner w-full md:h-full"
                :to="typeof ctaLink != 'string' || !ctaLink.startsWith('http') ? ctaLink : null"
                :href="typeof ctaLink == 'string' && ctaLink.startsWith('http') ? ctaLink : null"
                :target="typeof ctaLink == 'string' && ctaLink.startsWith('http') && ctaLinkNewTab ? '_blank' : null"
                v-on="ctaLink ? { click: () => ga.send({ label: 'voirProductRecette' }) } : {}"
            >
                <div class="RecipeProductCta__cover-wrapper overflow-hidden rounded-xl shadow-xl md:h-full">
                    <Cover
                        class="h-54 w-full md:h-full md:w-120"
                        :clip-path="false"
                        :data="image"
                    />
                    <div class="absolute inset-0 rounded-xl bg-gradient-to-t from-black/30" />
                </div>
                <Btn
                    v-if="ctaMain != ''"
                    color="currentColor"
                    class="RecipeProductCta__cta absolute bottom-4 left-4 md:left-52 xl:left-8"
                    :text="ctaMain"
                    size="small"
                />
            </component>
        </div>
        <div class="RecipeProductCta__infos px-6 pt-12 md:py-12 md:pl-10 md:pr-18 xl:py-18 xl:pl-18 xl:pr-36">
            <h2
                class="h3 RecipeProductCta__title"
                :class="[
                    'text-dark-' + mainColor,
                    {
                        '!text-white': mainColor == 'indigo',
                    },
                ]"
                v-html="title"
            />
            <div class="RecipeProductCta__parallax">
                <div class="RecipeProductCta__parallax-inner my-6">
                    <slot name="text" />
                </div>
                <BtnPill
                    :color="'dark-' + mainColor"
                    :icon="btnIcon"
                    :to="typeof ctaMainLink != 'string' || !ctaMainLink.startsWith('http') ? ctaMainLink : null"
                    :href="typeof ctaMainLink == 'string' && ctaMainLink.startsWith('http') ? ctaMainLink : null"
                    :external="typeof ctaMainLink == 'string' && ctaMainLink.startsWith('http')"
                    :target="typeof ctaMainLink == 'string' && ctaMainLink.startsWith('http') && ctaMainLinkNewTab ? '_blank' : null"
                    v-on:click="ga.send({ label: 'voirProductToutesRecettes' })"
                >
                    <template
                        v-if="ctaSmall || cta"
                        #label
                    >
                        <span
                            v-if="ctaSmall"
                            class="md:hidden"
                            >{{ ctaSmall }}</span
                        >
                        <span
                            v-if="cta"
                            class="hidden md:inline"
                            >{{ cta }}</span
                        >
                    </template>
                    <template #text>
                        {{ ctaMainSub }}
                    </template>
                </BtnPill>
            </div>
        </div>
    </div>
</template>
